import { FixedBuyBlock, Price } from '../styled.components'
import { Course } from '@type/course'
import useScrollDirection from '@hooks/useScrollDirection'
import { useTranslation } from 'react-i18next'
import Button from '@components/atoms/Button'
import { useAuth } from '@contexts/Auth'
import { colors } from '@configs/styles/config'

type Props = {
  isTitleInViewPort: boolean
  course: Course
  avgRating: number
  buyNowHandler: () => void
}

const FixedBuyNow = ({
  course,
  isTitleInViewPort,
  avgRating,
  buyNowHandler,
}: Props) => {
  const { t } = useTranslation([
    'common',
    'review',
    'stickyCoursePageBlock',
    'courseReviews',
  ])
  const { isScrollingUp } = useScrollDirection()
  const { user } = useAuth()

  return (
    <FixedBuyBlock
      isScrollingUp={isScrollingUp}
      isTitleInViewPort={isTitleInViewPort}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}
        className="w-full"
      >
        <span
          style={{
            margin: 0,
            marginLeft: '-3px',
            marginBottom: '0.65rem',
            marginTop: 0,
          }}
          className="font-semiBold sm:text-[1.2rem] text-[16px]"
        >
          {course?.title || 'No titles'}
        </span>

        <div className="flex justify-between items-center">
          <div
            style={{
              fontSize: 15,
              display: 'flex',
              alignItems: 'center',
              gap: 5,
            }}
          >
            <svg
              width="19"
              height="19"
              viewBox="0 0 17 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.53405 13.4766L4.72296 15.473C3.98912 15.8574 3.13288 15.234 3.27341 14.4176L4.00034 10.1944L0.924323 7.20673C0.329011 6.62851 0.656424 5.61863 1.47776 5.49971L5.73206 4.88373L7.63795 1.03579C8.00523 0.294238 9.06287 0.29424 9.43016 1.03579L11.336 4.88373L15.5903 5.49971C16.4117 5.61863 16.7391 6.62851 16.1438 7.20672L13.0678 10.1944L13.7947 14.4176C13.9352 15.234 13.079 15.8574 12.3451 15.473L8.53405 13.4766Z"
                fill="#1A1E3D"
              />
            </svg>
            <span className="text-[15px] text-uguPurple font-semiBold">
              {avgRating.toFixed(1)}
            </span>
            <span className="text-[15px] text-gray-500 font-regular">
              {course.studentsQty && course.studentsQty > 0
                ? '(' +
                  new Intl.NumberFormat('en-US', {
                    maximumFractionDigits: 0,
                  }).format(course.studentsQty) +
                  ')'
                : '1,000'}
            </span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <span className="flex items-center gap-[2px]">
              <span className="font-semiBold text-[1.1rem] tracking-[0rem]">
                {course.price
                  ? course.salePrice
                    ? `$${course.salePrice / 100}`
                    : `$${course.price / 100}`
                  : 'Free'}
              </span>
              {course.salePrice && course.salePrice < (course.price || 0) && (
                <>
                  <Price active>/</Price>
                  <Price>${(course.price || 0) / 100}</Price>
                </>
              )}
            </span>
            {user?.purchased_courses?.includes(course._id) ||
              user?.my_courses?.includes(course._id) || (
                <Button
                  backgroundColor={colors.uguBrightPurple}
                  color={'white'}
                  borderRadius="6px"
                  padding="1rem"
                  fontSize="16px"
                  onClick={buyNowHandler}
                >
                  {t('buttons.buyNow')}
                </Button>
              )}
          </div>
        </div>
      </div>
    </FixedBuyBlock>
  )
}

export default FixedBuyNow
